/** @jsx jsx */
import { jsx } from '@compiled/react';
import Anchor from '@atlaskit/primitives/anchor';
import { Text, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { CORE_PROJECT, SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { THIRD_PARTY_SOURCE_SLACK } from '@atlassian/jira-issue-view-common-types/src/comment-type.tsx';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const SlackLink = () => {
	const { formatMessage } = useIntl();

	const { projectType, thirdPartyLink, thirdPartyCommentSource } = useCommentContext();
	if (
		!fg('jira_issue_view_show_slack_sync_info') ||
		(projectType !== SOFTWARE_PROJECT && projectType !== CORE_PROJECT) ||
		!thirdPartyLink ||
		thirdPartyCommentSource !== THIRD_PARTY_SOURCE_SLACK
	) {
		return null;
	}
	return (
		<Tooltip content={formatMessage(messages.viaSlackTooltip)}>
			{(tooltipProps) => (
				<Text size="small">
					<Anchor
						{...tooltipProps}
						xcss={anchorStyles}
						href={thirdPartyLink}
						target="_blank"
						rel="noopener noreferrer"
						testId="issue-comment-base.ui.comment.custom-comment.link"
						aria-label={formatMessage(messages.viaSlack)}
					>
						{formatMessage(messages.viaSlack)}
					</Anchor>
				</Text>
			)}
		</Tooltip>
	);
};

export default SlackLink;

const anchorStyles = xcss({
	color: 'color.text.subtlest',
	textDecoration: 'none',
	':hover': {
		color: 'color.text',
		textDecoration: 'underline',
	},
	':focus': {
		color: 'color.text.subtlest',
		textDecoration: 'none',
	},
	':active': {
		color: 'color.text.subtlest',
		textDecoration: 'none',
	},
	':visited': {
		color: 'color.text.subtlest',
		textDecoration: 'none',
	},
	':visited:active': {
		color: 'color.text.subtlest',
		textDecoration: 'none',
	},
});
